
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbTabsetModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularFireModule } from '@angular/fire'
import { AngularFireAuthModule } from '@angular/fire/auth'
import { AngularFirestoreModule } from '@angular/fire/firestore'
import { AppComponent } from './app.component';
import { MatTabsModule } from '@angular/material/tabs';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClientModule, HttpClient  } from '@angular/common/http';
import {NgxWebstorageModule} from 'ngx-webstorage';



import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './views/home/home.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { FeaturesComponent } from './components/features/features.component';
import { QuickmenuComponent } from './components/quickmenu/quickmenu.component';
import { ContactsecComponent } from './components/contactsec/contactsec.component';
import { FooterComponent } from './components/footer/footer.component';
import { MenuComponent } from './views/menu/menu.component';
import { AppRoutingModule } from './app-routing.module';
import { GalleryComponent } from './views/gallery/gallery.component';
import { AboutusComponent } from './views/aboutus/aboutus.component';
import { ContactComponent } from './views/contact/contact.component';
import { CartComponent } from './views/cart/cart.component';
import { CheckoutComponent } from './views/checkout/checkout.component';
import { SingleprodComponent } from './views/singleprod/singleprod.component';
import { TablenoComponent } from './views/tableno/tableno.component';
import { from } from 'rxjs';
import { LoginComponent } from './views/login/login.component';
import { ChangenoComponent } from './views/changeno/changeno.component';
import { SumPipe } from './pipes/sum.pipe';
import { CheckoutguardviewComponent } from './views/checkoutguardview/checkoutguardview.component';
import { GalleryCarouselComponent } from './components/gallery-carousel/gallery-carousel.component';
import { GeneralReviewsComponent } from './views/general-reviews/general-reviews.component';
import { ViewcommentsComponent } from './components/viewcomments/viewcomments.component';
import { SwitcherComponent } from './dashboard/switcher/switcher.component';
import { DashboardLoginComponent } from './dashboard/dashboard-login/dashboard-login.component';
import { OrdersLoginComponent } from './dashboard/orders-login/orders-login.component';
import { DashboardPanelComponent } from './dashboard/dashboard-panel/dashboard-panel.component';
import { OrdersPanelComponent } from './dashboard/orders-panel/orders-panel.component';
import { MustlogoutComponent } from './components/mustlogout/mustlogout.component';
import { OrdersPanalInstacComponent } from './dashboard/orders-panal-instac/orders-panal-instac.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { AddMenuComponent } from './dashboard/add-menu/add-menu.component';
import { ViewUsersComponent } from './dashboard/view-users/view-users.component';
import { ViewReviewsComponent } from './dashboard/view-reviews/view-reviews.component';
import { AddCarouselComponent } from './dashboard/add-carousel/add-carousel.component';
import { AddGalleryComponent } from './dashboard/add-gallery/add-gallery.component';
import { ViewContactComponent } from './dashboard/view-contact/view-contact.component';
import { PanelLogoutComponent } from './dashboard/panel-logout/panel-logout.component';
import { NotFoundComponent } from './views/not-found/not-found.component';
import { LetsStartComponent } from './views/lets-start/lets-start.component';
import { CheckMailComponent } from './views/check-mail/check-mail.component';
import { AddCrewComponent } from './dashboard/add-crew/add-crew.component';
import { ViewAboutComponent } from './dashboard/view-about/view-about.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    HomeComponent,
    CarouselComponent,
    FeaturesComponent,
    QuickmenuComponent,
    ContactsecComponent,
    FooterComponent,
    MenuComponent,
    GalleryComponent,
    AboutusComponent,
    ContactComponent,
    CartComponent,
    CheckoutComponent,
    SingleprodComponent,
    TablenoComponent,
    LoginComponent,
    ChangenoComponent,
    SumPipe,
    CheckoutguardviewComponent,
    GalleryCarouselComponent,
    GeneralReviewsComponent,
    ViewcommentsComponent,
    SwitcherComponent,
    DashboardLoginComponent,
    OrdersLoginComponent,
    DashboardPanelComponent,
    OrdersPanelComponent,
    MustlogoutComponent,
    OrdersPanalInstacComponent,
    SidebarComponent,
    AddMenuComponent,
    ViewUsersComponent,
    ViewReviewsComponent,
    AddCarouselComponent,
    AddGalleryComponent,
    ViewContactComponent,
    PanelLogoutComponent,
    NotFoundComponent,
    LetsStartComponent,
    CheckMailComponent,
    AddCrewComponent,
    ViewAboutComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MDBBootstrapModule.forRoot(),
    FormsModule,
    NgbModule,
    NgbTabsetModule,
    AppRoutingModule,
    AngularFireModule.initializeApp({
      apiKey: "AIzaSyDsZDT4WaHVqVddOKxYKoCBK6Yeb-4TX48",
      authDomain: "elmenu-87402.firebaseapp.com",
      databaseURL: "https://elmenu-87402.firebaseio.com",
      projectId: "elmenu-87402",
      storageBucket: "elmenu-87402.appspot.com",
      messagingSenderId: "634230429132",
      appId: "1:634230429132:web:10ec7bc3d53d49ba107969",
      measurementId: "G-QQQK71Y6PW"
    }),
    AngularFireAuthModule,
    AngularFirestoreModule,
    MatTabsModule,
    NgScrollbarModule,
    NgxWebstorageModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage:'ar',
      loader: {
        provide:TranslateLoader,
        useFactory:CreateTranslateLoader,
        deps:[HttpClient]
      }
    })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function CreateTranslateLoader(http:HttpClient) {
  return new TranslateHttpLoader(http,'./assets/i18n/','.json')
}
